import React, { useContext } from 'react';

import { putPropsToEventHandlers } from '../helpers/node';
import PlugOutIcon from '../../../resources/plugOut.svg';
import { useBaseStyles } from './BlockNode/style';
import { SchemaDisplayContext } from '../context';
import { ROOT_NODE_TYPE } from '../../constants';

function ConnectionSocketOut(props) {
  const { connectionPort } = useBaseStyles();
  const { topologyNodeType, className = '', alt = '' } = props;
  const { node: { connectionSocketOut: { eventHandlers } } } = useContext(SchemaDisplayContext);

  return topologyNodeType !== ROOT_NODE_TYPE ? (
    <img
      alt={alt}
      draggable={false}
      onDragStart={(event) => event.preventDefault()}
      className={`${connectionPort} ${className}`}
      src={PlugOutIcon}
      {...putPropsToEventHandlers(eventHandlers, props)}
    />
  ) : null;
}

export default ConnectionSocketOut;
